<template>
  <div id="app">
    <my-header></my-header>
    <router-view></router-view>
    <my-footer></my-footer>
    <my-dialog ref = "openPop" name="header"></my-dialog>
    <join-dialog ref = "openJoinPop" name="join"></join-dialog>
  </div>
</template>

<script>
  import myHeader from './components/header.vue'
  import myFooter from './components/footer.vue'
  import MyDialog from './components/dialog.vue'
  import joinDialog from './components/dialog_join.vue'
  export default {
    name: 'App',
    components: {
      myHeader,
      myFooter,
      MyDialog,
      joinDialog
    }

  }
</script>
<style lang="less">
  @import "./assets/css/commen.less";
</style>


// WEBPACK FOOTER //
// src/App.vue